import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

/**
 * Single shared backend client for the whole app (singleton).
 * Every component and hook imports this instance instead of creating its own.
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey);